// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const GraphicVideoBackground: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="842" height="421" viewBox="0 0 842 421" fill="currentColor">
            <g fill="none" fillRule="evenodd" stroke="#FFF" strokeWidth="2" opacity=".03" transform="translate(1 1)">
                <path d="M373.334965,420 C373.334965,394.222315 394.229209,373.328437 420,373.328437 C445.778135,373.328437 466.665035,394.222315 466.665035,420" />
                <path d="M326.669931,420 C326.669931,368.451975 368.451074,326.664219 420,326.664219 C471.548926,326.664219 513.337413,368.451975 513.337413,420" />
                <path d="M279.997552,420 C279.997552,342.681635 342.680283,280 420,280 C497.319717,280 560.002448,342.681635 560.002448,420" />
                <path d="M233.332517,420 C233.332517,316.90395 316.909492,233.335781 420,233.335781 C523.097853,233.335781 606.667483,316.90395 606.667483,420" />
                <path d="M186.667483,420 C186.667483,291.13361 291.131356,186.664219 420,186.664219 C548.868644,186.664219 653.332517,291.13361 653.332517,420" />
                <path d="M140.002448,420 C140.002448,265.363269 265.360565,140 420,140 C574.639435,140 700.004896,265.363269 700.004896,420" />
                <path d="M93.3300692,420 C93.3300692,239.585585 239.589774,93.3357814 420,93.3357814 C600.41757,93.3357814 746.669931,239.585585 746.669931,420" />
                <path d="M46.6650346,420 C46.6650346,213.815244 213.811639,46.6715627 420,46.6715627 C626.188361,46.6715627 793.334965,213.815244 793.334965,420" />
                <path d="M373.334965,420 C373.334965,394.222315 394.229209,373.328437 420,373.328437 C445.778135,373.328437 466.665035,394.222315 466.665035,420" />
                <path d="M0,420 C0,188.03756 188.040848,0 420,0 C651.959152,0 840,188.03756 840,420" />
            </g>
        </svg>
    );
};

export default React.memo(GraphicVideoBackground);
